var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.content)?_c('a',{staticClass:"clickable",attrs:{"target":"_blank","title":"Instructions"},on:{"click":function($event){return _vm.showNotes(_vm.title, _vm.content)}}},[_vm._t("default",function(){return [_c('information-icon',{attrs:{"title":'Instructions',"fillColor":'#0069AA',"size":18}})]})],2):_c('span',[_vm._v("-")])])
}
var staticRenderFns = []

export { render, staticRenderFns }